"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = require("lodash");
exports.defaultConfig = {
    gqlEndPoint: 'https://athlete-ui-api-stage.athlinks.com/graphql',
    cachingEnabled: false
};
var config = __assign({}, exports.defaultConfig);
exports.getAthleteAPIClientConfig = function () { return config; };
exports.resetConfig = function () {
    config = __assign({}, exports.defaultConfig);
};
exports.getGqlEndPoint = function () {
    var gqlEndPoint = exports.getAthleteAPIClientConfig().gqlEndPoint;
    if (!gqlEndPoint) {
        throw new Error('gqlEndPoint must be set. ' +
            'For example: athlete-ui-api-stage.athlinks.com/graphql');
    }
    return gqlEndPoint;
};
exports.isCachingEnabled = function () { return exports.getAthleteAPIClientConfig().cachingEnabled; };
var stripTrailingSlash = function (url) { return url && url.replace(/\/$/, ''); };
exports.configureAthleteAPIClient = function (_a) {
    var gqlEndPoint = _a.gqlEndPoint, theRest = __rest(_a, ["gqlEndPoint"]);
    return config = __assign({ gqlEndPoint: stripTrailingSlash(gqlEndPoint) }, theRest);
};
exports.getClientConfigurationErrors = function () {
    return lodash_1.flow([
        lodash_1.partialRight(lodash_1.map, function (foo) {
            try {
                foo();
            }
            catch (error) {
                console.log('GOT ERROR', error.message);
                return error.message;
            }
        }),
        lodash_1.partialRight(lodash_1.filter, function (x) { return x; })
    ])([exports.getGqlEndPoint]);
};
//# sourceMappingURL=index.js.map


/*****************
 ** WEBPACK FOOTER
 ** ../~/athlete-api-client/dist/config/index.js
 ** module id = 361
 ** module chunks = 0
 **/